import axios from "./../plugins/axios.js";

// Auth
export async function login(paramsLogin) {
  const { data } = await axios
    .post("auth/login", paramsLogin)
    .then(res => res)
    .catch(error => {
      if (
        error.message ==
        "Cannot read properties of undefined (reading 'status')"
      ) {
        alert("Network Error");
      } else {
        return {
          data: {
            error: error
          }
        };
      }
    });
  return data;
}

//Config forgot
export async function forgot(paramsForgot) {
  const { data } = await axios
    .post("forgot-password", paramsForgot)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function signup(paramSignup) {
  const { data } = await axios
    .post("auth/signup", paramSignup)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function editTeacher(paramEditTeacher) {
  const { data } = await axios
    .post(`auth/edit/${paramEditTeacher.id}`, paramEditTeacher)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function logout(token) {
  const { data } = await axios
    .post("auth/logout", token)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function resetPassword(paramsResetPassword) {
  const { data } = await axios
    .post("auth/change-password", paramsResetPassword)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

// Admin/Category
export async function getListCategory() {
  const { data } = await axios
    .get("category")
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function deleteCategory(categoryId) {
  const { data } = await axios
    .delete(`categories/${categoryId}`)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function createCategory(paramsCategory) {
  const { data } = await axios
    .post("categories", paramsCategory)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getDetailCategory(categoryId) {
  const { data } = await axios
    .get(`categories/${categoryId}`)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function editCategory(paramsEditCategory) {
  const { data } = await axios
    .put(`categories/${paramsEditCategory.id}`, {
      name: paramsEditCategory.name,
      code: paramsEditCategory.code
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

// Admin/Problem
export async function getListProblem(paramsListProblem) {
  let listTag = [];
  for (let i = 0; i < paramsListProblem.selected.tagId.length; i++) {
    listTag.push(paramsListProblem.selected.tagId[i].value);
  }
  const { data } = await axios
    .get("problems", {
      params: {
        keyword: paramsListProblem.search,
        keyword_level: paramsListProblem.selected.level,
        page: paramsListProblem.page,
        keyword_tags: listTag,
        category: paramsListProblem.selected.category_id,
        perPage: paramsListProblem.selected.paginate
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function createProblem(problemId) {
  const { data } = await axios
    .post("problems", problemId)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getDetailProblem(problemId) {
  const { data } = await axios
    .get(`problems/${problemId}`)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getListUserSubmittions(problemId) {
  const { data } = await axios
    .get(`user_answer/submittions/${problemId}`)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function editProblem(paramsEditProblem) {
  const { data } = await axios
    .put(`problems/${paramsEditProblem.id}`, {
      title: paramsEditProblem.data.title,
      category_id: paramsEditProblem.data.selected.category_id,
      level: paramsEditProblem.data.selected.level,
      content: paramsEditProblem.data.content,
      description: paramsEditProblem.data.description,
      tagId: paramsEditProblem.tagId
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function deleteProblem(problemId) {
  const { data } = await axios
    .delete(`problems/${problemId}`)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

// Admin/UserAnswer
export async function getListUserAnswer(paramsUserAnswer) {
  const { data } = await axios
    .get("user_answer", {
      params: {
        keyword: paramsUserAnswer.search,
        level: paramsUserAnswer.selected.level,
        category: paramsUserAnswer.selected.category_id,
        page: paramsUserAnswer.page,
        perPage: paramsUserAnswer.selected.paginate
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

// Admin/User
export async function getUser() {
  const { data } = await axios.get("/user");
  return data;
}

export async function getStudent() {
  const { data } = await axios.get("/student");
  return data;
}

// User/ProblemHome
export async function getProblemsHome(paramsProblemHome) {
  let listTag = [];
  for (let i = 0; i < paramsProblemHome.selected.tags.length; i++) {
    listTag.push(paramsProblemHome.selected.tags[i].value);
  }
  const { data } = await axios
    .get("problemsHome", {
      params: {
        category: paramsProblemHome.category,
        perPage: paramsProblemHome.selected.perPage,
        page: paramsProblemHome.page,
        keyword: paramsProblemHome.search,
        category_id: paramsProblemHome.category,
        level: paramsProblemHome.selected.level,
        tags: listTag
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

// Get List Tag
export async function getListTag() {
  const { data } = await axios
    .get("tag")
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function createUserAnswer(paramsUserAnswer) {
  const { data } = await axios
    .post("user_answer", paramsUserAnswer)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getDetailUserAnswer(userAnswerId) {
  const { data } = await axios
    .get(`user_answer/${userAnswerId}`)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function changeStatusAnswer(paramsUserAnswer) {
  const { data } = await axios
    .put(`user_answer/${paramsUserAnswer.id}`, {
      status: paramsUserAnswer.status
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getNewProblem() {
  const { data } = await axios
    .get("new-problem")
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getListUserAnswerByUserId(paramsGetListByUserId) {
  const { data } = await axios
    .get("listUserAnswerById", {
      params: {
        perPage: paramsGetListByUserId.selected.paginate,
        page: paramsGetListByUserId.page
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getListUser(paramsGetListUser) {
  const { data } = await axios
    .get("users", {
      params: {
        keyword: paramsGetListUser.search,
        status: paramsGetListUser.selected.status,
        roles: paramsGetListUser.selected.role_teacher,
        nation: paramsGetListUser.selected.nations,
        permission_create_question: paramsGetListUser.selected.permission_create_question,
        permission_create_exam: paramsGetListUser.selected.permission_create_exam,
        permission_delete_question: paramsGetListUser.selected.permission_delete_question,
        permission_delete_exam: paramsGetListUser.selected.permission_delete_exam,
        category: paramsGetListUser.selected.category,
        page: paramsGetListUser.page,
        perPage: paramsGetListUser.selected.paginate
      }
    })
    .then(res => res)
    // .then(res => {
    //     const response =res;
    // })
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function deleteUser(userId) {
  const { data } = await axios
    .delete(`users/${userId}`)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getRole() {
  const { data } = await axios
    .get("getRole")
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function changeRole(paramsChangeRole) {
  const { data } = await axios
    .post("users/change-role", paramsChangeRole)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getDetailUser(userId) {
  const { data } = await axios
    .get(`users/${userId}`)
    .then(res => res)
    .catch(error => {
      return {
        error: error
      };
    });
  return data;
}

export async function changeProfile(paramsProfile) {
  const { data } = await axios
    .post("users/change-profile", paramsProfile)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getGrade() {
  const { data } = await axios
    .get("grade")
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getDifficulty() {
  const { data } = await axios
    .get("difficulty")
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}
export async function deleteDiff(id) {
  const { data } = await axios
    .delete(`difficulty/${id}`)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}
export async function createDiff(params) {
  const { data } = await axios
    .post("difficulty", params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function editDiff(params) {
  const { data } = await axios
    .patch(`difficulty/${params.id}`, params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function deleteGrade(id) {
  const { data } = await axios
    .delete(`grade/${id}`)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function createGrade(params) {
  const { data } = await axios
    .post("grade", params)

    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function editGrade(params) {
  const { data } = await axios
    .patch(`grade/${params.id}`, params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getListExams() {
  const { data } = await axios
    .get("list-exams-b2b")
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getListTopicsB2B() {
  const { data } = await axios
    .get("list-topics-b2b")
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getCategory() {
  const { data } = await axios
    .get("list-category")
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getCategoryB2C() {
  const { data } = await axios
    .get("list-category-b2c")
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function deleteCate(id) {
  const { data } = await axios
    .delete(`category/${id}`)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function createCate(params) {
  const { data } = await axios
    .post("category", params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function createLogo(params) {
  const { data } = await axios
    .post("logo/store", params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getLogo() {
  const { data } = await axios
    .get("logo")
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function editCate(params) {
  const { data } = await axios
    .patch(`category/${params.id}`, params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getListQuestion(paramsGetListQuestion) {
  const { data } = await axios
    .get("group-questions", {
      params: {
        keyword: paramsGetListQuestion?.search,
        category: paramsGetListQuestion?.selected.category,
        type: paramsGetListQuestion?.selected.typeQuestion,
        typeOfQuestion: paramsGetListQuestion?.selected.typeOfQuestion,
        difficulty: paramsGetListQuestion?.selected.difficulty,
        score_from: paramsGetListQuestion?.selected.score_from,
        score_to: paramsGetListQuestion?.selected.score_to,
        id_topic: paramsGetListQuestion?.selected.id_topic,
        page: paramsGetListQuestion?.page,
        perPage: paramsGetListQuestion?.selected.paginate,
        status: paramsGetListQuestion?.statusQuestion
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getListAllQuestion(id) {
  const { data } = await axios
    .get("all-questions/" + id)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getExam(paramsGetListExam) {
  const { data } = await axios
    .get("exam", {
      params: {
        keyword: paramsGetListExam.search,
        page: paramsGetListExam.page,
        category: paramsGetListExam.category,
        perPage: paramsGetListExam.selected.paginate
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getStudentExamList(paramsGetListExam) {
  const { data } = await axios
    .get("exam-all", {
      params: {
        keyword: paramsGetListExam.search,
        page: paramsGetListExam.page,
        category: paramsGetListExam.category,
        perPage: paramsGetListExam.selected.paginate
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getInfoExam(id) {
  const { data } = await axios
    .get("exam/" + id)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getSubmitDetail(id) {
  const { data } = await axios
    .get("answer-writing/" + id)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function createExam(params) {
  const { data } = await axios
    .post("exam", params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function updateExam(param) {
  const { data } = await axios
    .post("exam/" + param.id + "?_method=PATCH", param.body)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function deleteExam(id) {
  const { data } = await axios
    .delete("exam/" + id)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getAutoExam(params) {
  const { data } = await axios
    .post("exam/random-question", params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function createQuestions(params) {
  const { data } = await axios
    .post("group-questions", params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

//TOPICS
export async function createTopics(params) {
  const { data } = await axios
    .post("topics", params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getTopicList(paramsGetListQuestion) {
  // export async function getTopicList() {
  const { data } = await axios
    .get("topics", {
      params: {
        keyword: paramsGetListQuestion.search,
        category: paramsGetListQuestion.selected.category,
        keyword_type: paramsGetListQuestion.selected.typeTopic,
        keyword_difficulty: paramsGetListQuestion.selected.difficulty,
        teacher: paramsGetListQuestion.selected.teacher,
        page: paramsGetListQuestion.page,
        perPage: paramsGetListQuestion.selected.paginate
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getOneTopic(topicId) {
  const { data } = await axios
    .get(`topics/${topicId}`)
    .then(res => res)
    .catch(error => {
      return {
        error: error
      };
    });
  return data;
}

export async function deleteTopic(params) {
    const { data } = await axios
      .delete(`topics/${params}`)
      .then(res => res)
      .catch(error => {
        return {
          data: {
            error: error
          }
        };
      });
    return data;
  }

export async function editQuestions(params) {
  const { data } = await axios
    .post(`group-questions/${params[1]}?_method=PATCH`, params[0], {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function deleteQuestions(params) {
  const { data } = await axios
    .delete(`group-questions/${params}`)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function importTopic(params) {
  const { data } = await axios
    .post("topic/import", params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function importQuestion(params) {
  const { data } = await axios
    .post("question/import", params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}
export async function exportQuestion(paramsGetListQuestion) {
  const { data } = await axios
    .get("question/export", {
      params: {
        keyword: paramsGetListQuestion?.search,
        category: paramsGetListQuestion?.selected.category,
        type: paramsGetListQuestion?.selected.typeQuestion,
        typeOfQuestion: paramsGetListQuestion?.selected.typeOfQuestion,
        difficulty: paramsGetListQuestion?.selected.difficulty,
        score_from: paramsGetListQuestion?.selected.score_from,
        score_to: paramsGetListQuestion?.selected.score_to,
        id_topic: paramsGetListQuestion?.selected.id_topic,
        page: paramsGetListQuestion?.page,
        perPage: 20000,
        status: paramsGetListQuestion?.statusQuestion
      },
      responseType: "blob"
    })
    .then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "questions.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function exportExam(params) {
  const { data } = await axios
    .get(`submit/export/` + params[0], {
      params: {
        keyword: params[1],
        page: 1,
        perPage: 20000
      },
      responseType: "blob"
    })
    .then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "student-list.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function exportTopic(paramsGetListQuestion) {
  const { data } = await axios
    .get("topic/export", {
      params: {
        keyword: paramsGetListQuestion?.search,
        category: paramsGetListQuestion?.selected.category,
        type: paramsGetListQuestion?.selected.typeQuestion,
        typeOfQuestion: paramsGetListQuestion?.selected.typeOfQuestion,
        difficulty: paramsGetListQuestion?.selected.difficulty,
        score_from: paramsGetListQuestion?.selected.score_from,
        score_to: paramsGetListQuestion?.selected.score_to,
        id_topic: paramsGetListQuestion?.selected.id_topic,
        page: paramsGetListQuestion?.page,
        perPage: 20000,
        status: paramsGetListQuestion?.statusQuestion
      },
      responseType: "blob"
    })
    .then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "topic.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function editTopics(params) {
  const { data } = await axios
    .post(`topics/${params[1]}?_method=PATCH`, params[0])
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function showEditQuestions(params) {
  const { data } = await axios
    .get(`group-questions/${params}`)
    .then(res => res)
    .catch(error => {
      console.error(error);
    });
  return data;
}

export async function getListTags(params) {
    const { data } = await axios
      .post("list-tags", params)
      .then(res => res)
      .catch(error => {
        return {
          data: {
            error: error
          }
        };
      });
    return data;
  }

export async function getScienceExam(params) {
    const { data } = await axios
        .post("submit-selected-science", params)
        .then(res => res)
        .catch(error => {
            return {
                data: {
                    error: error
                }
            };
        });
    return data;
}

export async function getHsaExamResults(params) {
    const { data } = await axios
        .post("submit-hsa-exam-results", params)
        .then(res => res)
        .catch(error => {
            return {
                data: {
                    error: error
                }
            };
        });
    return data;
}

export async function confirmCode(params) {
  const { data } = await axios
    .post("verify/pin", params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function newPasswordForgot(params) {
  const { data } = await axios
    .post("crate-new-pass", params)
    .then(res => res)
    .catch(error => {
      console.error(error);
    });
  return data;
}

// payment vnpay
export async function paymentvnpay(params) {
  const { data } = await axios
    .post("payment-vnpay", params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}
export async function paymentmomo(params) {
  const { data } = await axios
    .post("payment-momo", params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getExamInCart(id) {
  const { data } = await axios
    .get("exam-user?id=" + id)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}
export async function addExamToCard(params) {
  const { data } = await axios
    .post("exam-add", params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function deleteExamInCard(params) {
  const { data } = await axios
    .delete(`exam-delete/${params.id}`)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getExamStudent(params) {
  const { data } = await axios
    .get(`exam-student`, {
      params: {
        keyword: params.search,
        category: params.category,
        page: params.page,
        perPage: params.selected.paginate
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getResponePayment(params) {
  const { data } = await axios
    .post("update-exam-student", params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function loginStudent(params) {
  const { data } = await axios
    .post("/student/login", params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function autoLoginStudentB2B(params) {
  const { data } = await axios
    .post("/student/auto-login-b2b", params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getListExamPaper(params) {
  const { data } = await axios
    .get("exam-management", {
      params: {
        keyword: params.keyword,
        status: params.status,
        dateFrom: params.dateFrom,
        dateTo: params.dateTo,
        page: params.page,
        perPage: params.perPage
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}
export async function getListStudentInExam(params) {
  const { data } = await axios
    .get(`exam-management/SelectById/` + params.id, {
      params: {
        keyword: params.keyword
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function submitExam(params) {
  const { data } = await axios
    .post("submit", params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getListResultExam(params) {
  const { data } = await axios
    .post("get-results-exam", params)
    .then(res => res)
    .catch(err => {
      return {
        data: {
          error: err
        }
      };
    });
  return data;
}

export async function getDetailResultExam(params) {
  const { data } = await axios
    .post("get-results-detail-exam", params)
    .then(res => res)
    .catch(err => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function markWritingQues(params) {
  const { data } = await axios
    .post("mark-writing", params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getSubmitExam(params) {
  const { data } = await axios
    .get("submit", {
      params: {
        keyword: params.keyword,
        from: params.from,
        to: params.to,
        page: params.page,
        perPage: params.perPage
      }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getListPayment(params) {
  const { data } = await axios
    .get("payment-history", {
        params: params
    //   params: {
    //     keyword: params?.keyword,
    //     page: params?.page,
    //     dateFrom: params?.dateFrom,
    //     dateTo: params?.dateTo
    //   }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function addPayment(params) {
  const { data } = await axios
    .post("exam-pay", params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function editPayment(dataSend) {
  const { data } = await axios
    .patch("exam-pay/" + dataSend.id, dataSend.params)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getDataEmailForPayment(params) {
  const { data } = await axios
    .get("get-payment-email",{
        params: {
            keyword: params?.keyword,
        }
    })
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function getDataExamForPayment(params) {
  const { data } = await axios
    .get("get-payment-exam")
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}

export async function deletePayment(id) {
  const { data } = await axios
    .delete("payment-history/" + id)
    .then(res => res)
    .catch(error => {
      return {
        data: {
          error: error
        }
      };
    });
  return data;
}
export async function confirmPayment(id) {
    const { data } = await axios
        .post("payment-history/send-success/" + id)
        .then(res => res)
        .catch(error => {
            return {
                data: {
                    error: error
                }
            };
        });
    return data;
}

export async function rejectPayment(id) {
    const { data } = await axios
        .post("payment-history/send-fail/" + id)
        .then(res => res)
        .catch(error => {
            return {
                data: {
                    error: error
                }
            };
        });
    return data;
}

export async function getTransferExam(body) {
    const { data } = await axios
        .post("payment-history", { exam: body.exam })
        .then(res => res)
        .catch(error => {
            return {
                data: {
                    error: error
                }
            };
        });
    return data;
}

export async function getDataAnalysisExam(params) {
    const { data } = await axios
      .post("data-analysis-exam", params)
      .then(res => res)
      .catch(error => {
        return {
          data: {
            error: error
          }
        };
      });
    return data;
  }
export async function getHSATopics(id) {
    const { data } = await axios
        .get("hsa-vnu-topics/" + id)
        .then(res => res)
        .catch(error => {
            return {
                data: {
                    error: error
                }
            };
        });
    return data;
}

  export async function exportStudentResult(params) {
    var status = null;
    const { data } = await axios
      .get("submit/export-student-result", {
        params: params,
        responseType: "blob",
      })
     // .then(res => res)
      .then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "student_result.xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
        status = res.status;
       // data = 'aaa';
        return status;
       })
      .catch(error => {
        return {
          data: {
            error: error
          }
        };
      });
    return status;
  }
